



















import { Component, Prop, Vue } from 'vue-property-decorator';
import posed from 'vue-pose';

import ArrowDownIcon from '@/components/icons/Arrow.vue';

@Component({
  components: {
    Container: posed.div({
      visible: { height: 'auto' },
      hidden: { height: 48 }
    }),
    ArrowDownIcon
  }
})
export default class CollapseRow extends Vue {
  @Prop(String) title!: string;
  @Prop({ default: false }) opened?: boolean;
}
